import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import AccountServiceModel    from '@/models/AccountServiceModel';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Translatable           from '@widesk-core/models/traits/Translatable';
import Blamable               from '@/models/traits/Blamable';
import FunctionalityTypeModel from '@/models/services/account/FunctionalityTypeModel';

@model.urnResource('functionality')
@doc.path('/functionalities/{?id}')
export default class FunctionalityModel extends Blamable(TimestampAble(Translatable(AccountServiceModel, {
	title: true,
	description: true,
}))) {
	private declare _tsFilters: {
		'subscription': id;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare reference: Account_FunctionalityReference;
	@doc.model(FunctionalityTypeModel) declare type: FunctionalityTypeModel;

	public get title(): string | undefined {
		return this.translation('title');
	}
}
